import React from 'react';
import ReactDOM from 'react-dom';
import { loadWidget } from '@sitevision/react';
import YourProvisions from './templates/organisms/your-provisions';

loadWidget('.plf-your-provisions-area', yourProvisionAreaWidget => {
    const action = yourProvisionAreaWidget.dataset.action;
    ReactDOM.render(<YourProvisions action={action} />, yourProvisionAreaWidget);
});
